import React from "react"
import { Skeleton } from "@mui/material"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { StatusList } from "pages/assistant/components/Table/Tasks/statusList"
import { ReportPieChart } from "pages/assistant/components/Table/Tasks/pieChart"
import MDButton from "components/MDButton"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import BellIcon from "assets/images/apollo-english/bell.svg"
import NotFound from "assets/images/apollo-english/not-found.png"
import { descriptionTypography } from "shared/styles/style"

import {
  alertStyle,
  completionTitleStyle,
  myTasksContainerStyle,
  overdueTextStyle,
  toCompleteTextStyle,
} from "./style"

const PieChartLXOMyTask = ({
  classes,
  loading,
  tasksPieChart = {},
  taskOverdue,
  taskOnCompleteToday,
  label = "",
  labelChart,
}) => {
  return (
    <MDBox sx={myTasksContainerStyle}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <InfoIcon
          type={TooltipType.TYPE_1}
          teacherInfoIconBlock={teacherInfoIconBlock.REPORT_COMPLETION}
          color={TooltipIconColor.BLUE}
          className={classes.containerInfoIconWithHeading}
        >
          <MDBox>
            <MDTypography sx={completionTitleStyle}>{label}</MDTypography>
            {loading ? (
              <Skeleton
                variant="rectangular"
                height={60}
                sx={{ width: "100%" }}
              />
            ) : (
              <ReportPieChart data={tasksPieChart.data} label={labelChart} />
            )}
          </MDBox>
        </InfoIcon>
        <MDBox
          display="flex"
          sx={({ breakpoints }) => ({
            gap: 2.5,
            [breakpoints.down(1600)]: {
              gap: 0,
            },
          })}
        >
          <MDBox>
            <MDTypography sx={overdueTextStyle}>
              Overdue: {taskOverdue}
            </MDTypography>
            <MDTypography sx={toCompleteTextStyle}>
              To complete today: {taskOnCompleteToday}
            </MDTypography>
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={alertStyle}
          >
            <MDBox component="img" src={BellIcon} />
          </MDBox>
        </MDBox>
      </MDBox>
      {tasksPieChart.data.length > 0 ? (
        <>
          <MDBox
            display="flex"
            gap={5}
            mb={2}
            sx={({ breakpoints }) => ({
              [breakpoints.down("md")]: {
                flexDirection: "column",
              },
            })}
          >
            <StatusList list={tasksPieChart.data} />
          </MDBox>
        </>
      ) : (
        <MDBox
          sx={({ breakpoints }) => ({
            fontSize: 36,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "200px",
            flexGrow: 1,
            objectFit: "contain",

            [breakpoints.down(1600)]: {
              height: "160px",
            },
          })}
          component="img"
          src={NotFound}
        ></MDBox>
      )}
    </MDBox>
  )
}

export default PieChartLXOMyTask
